import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import { FaUserCircle, FaEye, FaHistory, FaSignOutAlt } from "react-icons/fa";
import { FaSyringe, FaUserDoctor, FaHeartPulse } from "react-icons/fa6";
import { MdAddHomeWork, MdWorkHistory, MdKey } from "react-icons/md";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
// import './ComponentsStyles/sidebar.css';
import logo from "../Assets/logo.png";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";

import { TbCoinRupeeFilled } from "react-icons/tb";
import { PiGraphBold } from "react-icons/pi";
import toast from "react-hot-toast";
export default function Corporatesidebar({ collapsed, setCollapsed }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigator = useNavigate();

  const tabs = [
    { name: "Corporate Report", to: "/corporate", icon: FaUserCircle },
    // { name: "Book Home Collection", to: "collection", icon: FaSyringe },
    { name: "Corporate Billing ", to: "billing", icon: MdAddHomeWork },
  ];

  const handleLogout = () => {
    localStorage.removeItem("userData");
    localStorage.removeItem("token");
    localStorage.removeItem("userType");
    localStorage.removeItem("rb_corp_creds");
    // sessionStorage.clear();

    // Optional: show message
    toast.success("You have been Sucessfully logged out.");

    // Redirect to login page
    navigator("/users/login", { replace: true });
  };

  return (
    <>
      <button className="mobile-toggle-btn" onClick={() => setMobileOpen(true)}>
        <div className="dotsection">
          <PiDotsThreeOutlineVerticalFill size={24} />
        </div>
        <img src={logo} alt="RB Diagnostic" className="mobile-logo" />
      </button>

      {/* Sidebar */}
      <div
        className={`dashboard-sidebar ${collapsed ? "collapsed" : ""} ${
          mobileOpen ? "mobile-open" : ""
        }`}
      >
        {/* Cross Button (Mobile only) */}
        <button
          className="sidebar-close-btn mobile-only"
          onClick={() => setMobileOpen(false)}
        >
          <X size={24} />
        </button>

        {/* Desktop Logo */}
        <div className="LogoDivSidebar desktop-only">
          <img
            src={logo}
            alt="RB Diagnostic"
            style={{
              visibility: collapsed ? "hidden" : "visible",
              cursor: "pointer",
            }}
            onClick={() => {
              navigator("/");
              setMobileOpen(false);
            }}
          />
        </div>

        {/* Collapse Button for Desktop */}
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="sidebar-toggle-btn desktop-only"
        >
          {collapsed ? (
            <ChevronRight color="black" />
          ) : (
            <ChevronLeft color="black" />
          )}
        </button>

        {/* Sidebar Tabs */}
        <ul className="sidebar-main-nav">
          {tabs.map((tab, indx) => (
            <li className="sidebar-nav-item" key={indx}>
              <NavLink
                to={tab.to}
                end={tab.to === "/dashboard"}
                className={({ isActive }) =>
                  `sidebar-nav-link ${isActive ? "active" : ""}`
                }
                style={{ justifyContent: collapsed ? "center" : "start" }}
                onClick={() => setMobileOpen(false)}
              >
                <tab.icon className="sidebar-icon" />
                {!collapsed && <span>{tab.name}</span>}
              </NavLink>
            </li>
          ))}
        </ul>

        {/* Bottom Logout */}
        <ul className="sidebar-main-nav bottomOption">
          <li className="sidebar-nav-item">
            <span
              className="sidebar-nav-link"
              style={{
                justifyContent: collapsed ? "center" : "start",
                cursor: "pointer",
              }}
              onClick={() => {
                setMobileOpen(false); // close sidebar (mobile)
                handleLogout(); // logout ONLY when clicked
              }}
            >
              <FaSignOutAlt className="sidebar-icon" size={20} />
              {!collapsed && <span>Log Out</span>}
            </span>
          </li>
        </ul>
      </div>

      {/* Overlay */}
      {mobileOpen && (
        <div
          className="mobile-overlay"
          onClick={() => setMobileOpen(false)}
        ></div>
      )}
    </>
  );
}
